
const texts = {
    title: 'Anbima',
    description: 'Somos uma empresa especializada em prestação de serviços de Reformas, restaurações, instalação e manutenção elétrica, serviços de pintura, projetos, perícia e laudos, dentre outras funções pertinentes à engenharia civil, contando com profissionais com experiência no segmento, altamente qualificados.'
};

export { texts };